module.exports = __webpack_public_path__ + "static/media/MyriadPro-Regular.326083a2.svg";